import resetPasswordConstants from '../constants/reset-password-constants';

export const validate = values => {
  const errors = {};

  if (!values[resetPasswordConstants.fields.password]) {
    errors[resetPasswordConstants.fields.password] = 'LOGIN.PASSWORD_REQUIRED';
  }

  if (values[resetPasswordConstants.fields.confirm_password] !== values[resetPasswordConstants.fields.password]) {
    errors[resetPasswordConstants.fields.confirm_password] = 'REGISTER.CONFIRM_PASSWORD_MATCH';
  }

  if (!values[resetPasswordConstants.fields.confirm_password]) {
    errors[resetPasswordConstants.fields.confirm_password] = 'REGISTER.CONFIRM_PASSWORD_REQUIRED';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/app/main/reset-password/validators/reset-password-validators.js